import React from 'react'
import '../Related Products/RelatedProducts.css'
import {  Container, Row } from 'react-bootstrap'
import ReusableRelatedProducts from '../desktop2-resaable/ReusableRelatedProducts'
const RelatedProducts = () => {
  return (
    <>
        <section id='Related-Products'>
            <Container>
                <h1>Related Products</h1>
                <Row style={{rowGap:'40px'}}>
                    <ReusableRelatedProducts img={"./imeges/Desktop2/orange.svg"}/>
                    <ReusableRelatedProducts img={"./imeges/Desktop2/stbarry.svg"}/>
                    <ReusableRelatedProducts img={"./imeges/Desktop2/Orange big.svg"}/>
                </Row>
            </Container>
        </section>
    </>
  )
}

export default RelatedProducts